import { render, staticRenderFns } from "./WorkerMenuFoodCard.vue?vue&type=template&id=151917ef&scoped=true"
import script from "./WorkerMenuFoodCard.vue?vue&type=script&lang=js"
export * from "./WorkerMenuFoodCard.vue?vue&type=script&lang=js"
import style0 from "./WorkerMenuFoodCard.vue?vue&type=style&index=0&id=151917ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151917ef",
  null
  
)

export default component.exports